module.exports = __webpack_public_path__ + "static/condo_design-5-f999d74ce7010aa6843975d4e899ab16.jpg";